import { connect } from "react-redux";
import Breadcrumbs from "./Breadcrumbs";

const mapStateToProps = ({ breadcrumbs = {} }) => {
  const { items = [] } = breadcrumbs;
  return {
    items,
  };
};

export default connect(mapStateToProps)(Breadcrumbs);



// WEBPACK FOOTER //
// ./src/components/Breadcrumbs/index.js